import type { ReactElement, ReactNode } from 'react'

import { Fonte, type Origem } from './fonte'

export interface TituloComFonteProps {
  titulo: string
  origem: Origem
  /** Campo exato da origem, no hover do selo. */
  campo?: string
  /** Ex.: um <Explicacao> ao lado do título. */
  children?: ReactNode
}

/** Cabeçalho de seção com o selo de origem do dado à direita. */
export function TituloComFonte({
  titulo,
  origem,
  campo,
  children,
}: TituloComFonteProps): ReactElement {
  return (
    <div className="flex items-start justify-between gap-2">
      <div className="flex items-center gap-1">
        <h2 className="font-semibold">{titulo}</h2>
        {children}
      </div>
      <Fonte origem={origem} campo={campo} />
    </div>
  )
}
